module.exports = __webpack_public_path__ + "static/img/bg_1.ba2dfee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_1.jpg
// module id = RaH1
// module chunks = 1